<template>
  <!-- 添加表单 -->
  <div>
    <div class="s_bor_cbed">
      <div class="s_bf58 s_flex_bian_c height-40 s_bb1 s_ptb0lr24">
        <div class="s_flex_ali">
          <FileTextFilled class="fz-18 m-r-10" />
          <p class="fz-16">{{form.rule_name || '新规则'}}</p>
        </div>
      </div>
      <div class="p-t-20">
        <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-item label="规则名" help='规则名最多60个字'>
            <a-input v-model:value="form.rule_name" placeholder='请输规则名'  :maxlength="60" />
          </a-form-item>
          <a-form-item label="关键字">
            <div class="s_bor_cd9 m-t-5">
              <div class="height-32 p-l-11 p-r-11 s_flex_ali">
                <a href="javascript:;" @click='addKeysOpen("")'>添加关键字</a>
              </div>
              <div>
                <div class="s_flex_bian_c height-32 p-l-11 p-r-11 s_bor_t_cd9" v-for='(items,indexs) in form.keywords'
                  :key='indexs'>
                  <p class="width50">{{items.name}}</p>
                  <div>
                    <a-button type="link" @click='items.is_matching = items.is_matching ? 0 : 1'>
                      {{items.is_matching ? '已全匹配':'未全匹配'}}</a-button>
                    <EditOutlined class="m-r-30 fz-16 m-l-20" @click='addKeysOpen(indexs)' />
                    <DeleteFilled class="fz-16" @click="del(indexs)" />
                  </div>
                </div>
              </div>
            </div>
          </a-form-item>
          <a-form-item label="回复">
            <div class="s_bor_cd9 ">
              <div class="height-38 s_flex_bian_c m-t-2 p-l-11 p-r-11">
                <div class="s_flex_ali">
                  <p class="width-120 s_shou" @click='addTextOpen("")'>
                    <EditOutlined class="m-r-10 fz-16" />文字</p>
                  <div class="width-120 s_shou s_po_re">
                    <PictureOutlined class="m-r-10 fz-16" />图片
                  <div class="s_po_ab_tl s_tou" v-if='form.replys.length < 5'>
                    <wxMaterial :size='{width:120,height:40}' :groupType='1' :image="file_url" :max="1"
                      v-on:handlechoose="selectImg" />
                  </div>
                  <div v-else class="s_po_ab_tl s_tou width-120 height-40" @click='openSelectImgText'></div>
                  </div>
                  <p class="width-120 s_shou" @click='openSelectImgText'>
                    <FileImageOutlined class="m-r-10 fz-16" />图文</p>
                    <!-- 音频 -->
                    <p class="width-120 s_shou" @click="audioType=true">
                    <CustomerServiceOutlined class="m-r-10 fz-16" />音频</p>
                    <!-- 视频 -->
                    <p class="width-120 s_shou" @click="videoType=true">
                    <PlaySquareOutlined class="m-r-10 fz-16" />视频</p>
                </div>
                <a-checkbox v-model:checked="form.reply_all" @change="onChange">全部回复</a-checkbox>
              </div>
              <div>
                <div class="p-t-10 p-l-24 p-b-10 p-r-24 s_bor_t_cd9 s_flex_bian" v-for='(items,indexs) in form.replys'
                  :key='indexs'>
                  <div class="clearfix width90">
                    <p class="width5 fl">{{items.type_name}}</p>
                    <p class="width95 fl" v-if='items.type== 1'>{{items.content}}</p>
                    <p class="fl" v-if='items.type== 3 || items.type== 4'>{{items.title}}</p>
                    <img v-if='items.type== 2' class="width-110 height-110"
                      :src="items.image.indexOf(info.picdomain) == -1 ? info.picdomain+'/'+items.image : items.image"
                      alt="">
                        <p class="fl" v-if='items.type== 5'>{{items.title}}</p>
                        <p class="fl" v-if='items.type== 6'>{{items.title}}</p>
                  </div>
                  <div>
                    <EditOutlined v-if='items.type== 1' @click='addTextOpen(indexs)' class="m-r-30 fz-16 s_shou" />
                    <DeleteFilled class="fz-16 s_shou" @click='delreplyItem(indexs,items)' />
                  </div>
                </div>
              </div>
            </div>
          </a-form-item>
        </a-form>
      </div>
      <div class="s_bf58 s_flex_bian_c height-50 s_bt1 s_ptb0lr24">
        <p>文字({{form.replys.filter(v=>v.type==1).length}})、 图片({{form.replys.filter(v=>v.type==2).length}})、
          图文({{form.replys.filter(v=>v.type==3).length+form.replys.filter(v=>v.type==4).length}})、 音频({{form.replys.filter(v=>v.type==5).length}})、 视频({{form.replys.filter(v=>v.type==6).length}})</p>
          
        <div>
          <a-button type="primary" @click='addKeyreply("add")'>保存</a-button>
        </div>
      </div>
    </div>
  </div>
  <a-modal  :keyboard="false" title="添加文字回复" :width='800' centered v-model:visible="visible" destroyOnClose @ok="addTextItem"
    @cancel='textContent = "";textIndex = ""'>
    <div class="s_flex_bian_c m-b-25">
      <p></p>
      <div class="s_flex_ali">
        <p class="s_c666 m-r-10">{{title}}</p>
        <a-tooltip>
          <template #title>
            {{qpText}}
          </template>
          <QuestionCircleOutlined class="s_c376" />
        </a-tooltip>
      </div>
    </div>
    <a-textarea v-model:value="textContent" showCount :maxlength="600" :rows='8' placeholder='请输入' />
  </a-modal>
  <a-modal  :keyboard="false" title="添加关键字" centered v-model:visible="visibleKey" destroyOnClose @ok="addKeyItem"
    @cancel='key_name = "";keysIndex = ""'>
    <a-input v-model:value="key_name" placeholder='请输入' :maxlength="10" />
    <p class="s_c666 m-t-15 text-ar">最多10个字</p>
  </a-modal>
  <a-modal  :keyboard="false" title="选择图文" :width='1300' centered :footer="null" v-model:visible="graphicVisible" destroyOnClose>
    <graphic v-on:success='success' v-on:cancel='graphicVisible = false' />
  </a-modal>

   <a-modal  :keyboard="false" title="选择音频" :width='1300' centered :footer="null" v-model:visible="audioType" destroyOnClose>
    <audioModal @change="audioSelect"></audioModal>
  </a-modal>

   <a-modal :keyboard="false" title="选择视频" :width='1300' centered :footer="null" v-model:visible="videoType" destroyOnClose>
    <videoModal :videoID='videoData.id'   @change="videoSelect"></videoModal>
  </a-modal>
</template>
<script>
  import { EditOutlined, PictureOutlined, FileImageOutlined, QuestionCircleOutlined, FileTextFilled, DeleteFilled,CustomerServiceOutlined,PlaySquareOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs,onBeforeMount } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { wx_KeyreplyAdd, wx_KeyreplyEdit, wx_KeyreplyDel } from '@/api/public_wx'
  import store from "@/store";
   import audioModal from '../../menu/components/audioModal.vue';
    import videoModal from '../../menu/components/videoModal.vue';
  let defForm = {
    rule_name: '',
    keywords: [],
    replys: [],
    reply_all: 0
  }
  export default {
    components: { EditOutlined, PictureOutlined, FileImageOutlined, QuestionCircleOutlined, FileTextFilled, DeleteFilled,CustomerServiceOutlined,PlaySquareOutlined,audioModal,videoModal },
    setup(props, { emit }) {
      let form = ref({ ...defForm });
      const state = reactive({
        file_url: '',
        keysIndex: '',
        textIndex: '',
        key_name: '',
        textContent: '',
        info: store.state.user.info,
        listLoading: false,
        labelCol: { span: 2 },
        wrapperCol: { span: 20 },
        visibleKey: false,
        visible: false,
        graphicVisible: false,
        title: '文字回复可以用标签 <#微信昵称#> 显示会员微信昵称哦~',
        qpText: '后台设置：<#微信昵称#>终于等到你！ 用户关注后：高大永恒塑料制品有限公司后台 终于等到你！',
        videoType:false,
        audioType:false,
        videoData:{id:null}

      });
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");
      //  打开添加关键词
      const addKeysOpen = (index) => {
        if (index !== "") {
          state.visibleKey = true
          state.keysIndex = index
          state.key_name = form.value.keywords[index].name
        } else {
          if (form.value.keywords.length == 10) {
            message.error('最多只能添加10个关键词！');
          } else {
            state.visibleKey = true
          }
        }
      }
      const del=(index)=>{
        form.value.keywords.splice(index,1)
      }
      // 添加关键词
      const addKeyItem = () => {
        if (state.key_name == '') {
          message.error('请输入所要添加的关键词！');
        } else {
          if (state.keysIndex === '') {
            form.value.keywords.push({ name: state.key_name, is_matching: 0 })
            state.visibleKey = false
            state.key_name = ''
            state.keysIndex == ''
          } else {
            form.value.keywords[state.keysIndex].name = state.key_name
            state.visibleKey = false
            state.key_name = ''
            state.keysIndex == ''
          }
        }
      }
      // 打开添加文字内容
      const addTextOpen = (index) => {
        if (index !== "") {
          state.visible = true
          state.textIndex = index
          state.textContent = form.value.replys[index].content
        } else {
          if (form.value.replys.length == 5) {
            message.error('每条规则最多设置5条回复');
          } else {
            state.visible = true
          }
        }
       
      }
      // 添加文字内容
      const addTextItem = () => {
        if (state.textContent == '') {
          message.error('文字必须为1到600个字。');
        } else {
          if (state.textIndex === '') {
            form.value.replys.push({ type: 1, content: state.textContent, type_name: "文字" },)
            state.visible = false
            state.textContent = ''
            state.textIndex == ''
          } else {
            form.value.replys[state.textIndex].content = state.textContent
            state.visible = false
            state.textContent = ''
            state.textIndex == ''
          }
        }
         console.log(form.value.replys,'查看')
      }
      //选择图片
      const selectImg = (data) => {
        form.value.replys.push({ type: 2, content: data.data.media_id, type_name: "图片", image: data.imageUrl })
      }
      //选择图文
      const success = (e) => {
        form.value.replys.push({ type: e.media_id ? 3 : 4, content: e.media_id ? e.media_id : e.id, type_name: "图文", title: e.list[0].title })
        state.graphicVisible = false;
         console.log(form.value.replys,'查看2')
      }
      // 打开选择图文
      const openSelectImgText = () => {
        if (form.value.replys.length == 5) {
          message.error('每条规则最多设置5条回复');
          return false
        }
        state.graphicVisible = true
      }
      // 删除回复
      const delreplyItem = (index,items) => {
        form.value.replys.splice(index, 1)
        if(items.type==6){
             state.videoData = {id:null}
        }
      }
      //添加规则
      const addKeyreply = async (type) => {
        const hide = message.loading('正在加载中...', 0);
        let res = await wx_KeyreplyAdd({ ...form.value, keywords: JSON.stringify(form.value.keywords), replys: JSON.stringify(form.value.replys) }).then(res => res.data);
        if (iscode(res)) {
          emit("submit");
          setTimeout(hide); 
        } else {
          setTimeout(hide);
          message.error(res.msg);
        }
      }

      const audioSelect = function(data){
          
           form.value.replys.push({ type: 5, content:data.media_id , type_name: "音频", title: data.name || '无' })
           state.audioType = false;
      }

      const videoSelect = function(data){
            state.videoData = data;
            form.value.replys.push({ type: 6, content:data.media_id , type_name: "视频", title: data.name || '无' })
             state.videoType = false;
      }
      onMounted(() => {
        form.value = {
          rule_name: '',
          keywords: [],
          replys: [],
          reply_all: 0
        }
      });
      return {
        ...toRefs(state),
        form,
        addKeysOpen,
        addKeyItem,
        addTextOpen,
        addTextItem,
        selectImg,
        success,
        openSelectImgText,
        addKeyreply,
        delreplyItem,
        del,
        audioSelect,
        videoSelect
      };
    },
  };
</script>